function getTransformedImageSrc(src: string, prefix: string): string {
  if (!src) return src;

  const fileName = src.substr(src.lastIndexOf('/') + 1).split('.')[0];
  const transformedSrc = src.replace(fileName, fileName + prefix);
  return transformedSrc;
}

export default getTransformedImageSrc;
